import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "m32.587 7.925-18.41 18.41-6.764-6.765a.84.84 0 0 0-1.188 0l-1.979 1.98a.84.84 0 0 0 0 1.187l9.338 9.338a.84.84 0 0 0 1.187 0l20.983-20.983a.84.84 0 0 0 0-1.187l-1.98-1.98a.84.84 0 0 0-1.187 0Z" }));
export default SvgCheckmark;
